// extracted by mini-css-extract-plugin
export default {"input":"Input_input__CGkbt","error":"Input_error__WSei6","wrapper":"Input_wrapper__SoIOh","label":"Input_label__huk8n"};